<div class="container">
  <h1>{{'GTAC Template Management'|translate}}</h1>

  <section class="upload-section">
      <h2>{{'UPLOAD NEW TEMPLATE'|translate}}</h2>
      <div class="upload-form">
          <div class="file-input-wrapper">
              <label class="file-label">
                  <span class="browse-btn">{{'Browse'|translate}}</span>
                  <span class="file-name">{{ selectedFileName }}</span>
              </label>
              <input 
                  type="file" 
                  class="file-input" 
                  accept=".docx,.pdf" 
                  (change)="onFileSelected($event)">
          </div>
          <div class="notes-input-wrapper">
            <label for="templateNotes">{{'NOTES (OPTIONAL)'|translate}}</label>
            <textarea
                id="templateNotes"
                [(ngModel)]="newTemplateNotes"
                rows="2"
                placeholder="{{'Add relevant notes'|translate}}"></textarea>
          </div>
          <button
              type="button"
              class="upload-btn"
              (click)="onUpload()"
              [disabled]="!isFileSelected">
              {{'Upload'|translate}}
          </button>
      </div>
  </section>

  <!-- VERSION HISTORY SECTION -->
  <section class="version-history">
    <h2>{{'VERSION HISTORY'|translate}}</h2>
    <table>
        <thead>
            <tr style="background-color: #f5f5f5; font-weight: bold;">
                <th>{{'FILENAME'|translate}}</th>
                <th>{{'UPLOADED BY'|translate}}</th>
                <th>{{'UPLOADED AT'|translate}}</th>
                <th>{{'NOTES'|translate}}</th>
                <th>{{'ACTION'|translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngIf="showloading">
                <td colspan="5" style="text-align: center; padding: 20px;">
                    <div class="load">
                        <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="60" height="60" class="imgNoBorder">
                    </div>
                </td>
            </tr>
            <tr *ngFor="let template of gtacTemplateDto" [ngClass]="{'active-row': template.isActive === true}">
                <td>{{ template.fileName }}</td>
                <td>{{ template.createdBy }}</td>
                <td>{{ template.timestamp | date:'MMM dd, yyyy, hh:mma' }}</td>
                <td>{{ template.notes }}</td>
                <td>
                    <span *ngIf="template.isActive === true" class="status-active">{{'ACTIVE'|translate}}</span>
                    <a *ngIf="template.isActive === false" href="#" class="action-revert" (click)="revertVersion(template); $event.preventDefault();">{{'Revert'|translate}}</a>
                </td>
            </tr>
        </tbody>
    </table>
</section>
</div>